import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentLayout from '../../components/legal/LegalDocumentLayout';
import { getLegalPage } from '../../content/legal/legalPages';

const SUPPORT_EMAIL = 'cogni.dore@gmail.com';

function ContactPage() {
  const page = getLegalPage('contact');

  return (
    <LegalDocumentLayout page={page}>
      <div className="mt-10 rounded-lg border border-slate-200 bg-slate-50 p-6 sm:p-8">
        <h2 className="text-xl font-serif font-semibold text-slate-900 mb-4">
          Get in touch
        </h2>
        <p className="font-serif text-slate-700 text-[15px] leading-relaxed mb-6">
          Manage your subscription and account settings online, or email us for
          support.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/account"
            className="inline-flex items-center justify-center rounded-md bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition-colors"
          >
            Manage your account
          </Link>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="inline-flex items-center justify-center rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-800 hover:bg-slate-100 transition-colors"
          >
            Email us: {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </LegalDocumentLayout>
  );
}

export default ContactPage;
